import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet-async';

import HeroBanner from '../../component/heroBanner/HeroBanner';
import {organizationSchemaOrg, websiteSchemaOrg, SCHEMA_CONTEXT} from '../../util/schemaOrg';
import {homeUrl, webappURL} from '../../util/url';

import CuratedCollections from '../../component/curatedCollections/CuratedCollections';
import PopularBrands from './popularBrands/PopularBrands';
import PopularListings from './popularListings/PopularListings';
import DealsOfTheWeek from './dealsOfTheWeek/DealsOfTheWeek';
import HiddenGems from './hiddenGems/HiddenGems';
import WeLove from './weLove/WeLove';
import HomeOpenGraph from './HomeOpenGraph';
import HomeTwitterCard from './HomeTwitterCard';

import './Home.css';

export default function Home({ hostname }) {
    return (
        <div className="Home">
            <Helmet>
                <link rel="canonical" href={webappURL(hostname) + homeUrl()} />
                <link rel="alternate" type="application/atom+xml" href="/feed.atom" />
                <script type="application/ld+json">{JSON.stringify(organizationSchemaOrg(SCHEMA_CONTEXT))}</script>
                <script type="application/ld+json">{JSON.stringify(websiteSchemaOrg())}</script>
            </Helmet>
            <HomeOpenGraph hostname={hostname} />
            <HomeTwitterCard hostname={hostname} />
            {/* hidden h1 */}
            <h1 className="sr-only">빈티지 세컨핸드 패션 플랫폼</h1>

            {/* hero banner */}
            <HeroBanner autoPlayInterval={5000} />

            {/* popular listings */}
            <PopularListings />

            {/* popular brands */}
            <PopularBrands />

            {/* deals of the week */}
            <DealsOfTheWeek />

            {/* hidden gems */}
            <HiddenGems />

            {/* curated collections */}
            <CuratedCollections />

            {/* we love */}
            <WeLove />
        </div>
    );
}
Home.propTypes = {
    hostname: PropTypes.string.isRequired
};
